import { Trash2, AlertTriangle } from "lucide-react";
import { IOrganizationEvent } from "@/types/EventTypes";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../ui/Dialog";

interface DeleteConfirmDialogProps {
  event: IOrganizationEvent;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteConfirmDialog = ({
  event,
  onConfirm,
  onCancel,
}: DeleteConfirmDialogProps) => {
  return (
    <Dialog open={true} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="w-6 h-6 text-red-600" />
            <DialogTitle>Delete Event</DialogTitle>
          </div>
          <DialogDescription>
            Are you sure you want to delete the event{" "}
            <strong>"{event.name}"</strong>? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>

        <div className="bg-gray-50 rounded-lg p-4 my-2">
          <h4 className="font-medium text-gray-900 mb-2">Event Details:</h4>
          <div className="text-sm text-gray-600 space-y-1">
            <p>
              <strong>Name:</strong> {event.name}
            </p>
            <p>
              <strong>Description:</strong>
              <span
                dangerouslySetInnerHTML={{
                  __html: event.description || "No description provided",
                }}
              />
            </p>
            <p>
              <strong>Date:</strong>{" "}
              {event.date_from
                ? `${event.date_from}${event.date_to ? ` to ${event.date_to}` : ""}`
                : "No date set"}
            </p>
          </div>
        </div>

        <DialogFooter className="gap-2 sm:gap-0">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors duration-200"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors duration-200 flex items-center gap-2"
            autoFocus
          >
            <Trash2 size={16} />
            Delete Event
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
